window.a11yAnnounce = function(message, priority = 'polite') {
  const id = priority === 'assertive' ? 'a11y-announcer-assertive' : 'a11y-announcer';
  const el = document.getElementById(id);
  if (!el) return;
  // Clear then set — the DOM change is what triggers the announcement
  el.textContent = '';
  requestAnimationFrame(() => {
    el.textContent = message;
  });
};